import React from "react";
import _ from "lodash";
import numeral from "numeral";
import {
  parseTableData,
  filterDataToGroup,
} from "../IntegrationVerificationHelper";
import GroupDataTable from "./GroupDataTable";
import FilterControl from "./FilterControl";

class PredictedViewabilityView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      columns: [],
      groups: [],

      filterGroups: [],
      filterRecords: [],
      filterAmount: null,

      tags: [],
      alias: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const { records, columns } = this.props;

    const indexColumns = [
      columns[0],
      columns[1],
      "predicted_viewability_bucket",
      "b_impression",
      "o_impression",
      "total_impression",
    ];

    const arrangeColumns = [
      {
        key: "ext_gam_unit_id",
        label: "Ext Gam Unit Id",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "date",
        label: "Date",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "predicted_viewability_bucket",
        label: "Predicted Viewability Bucket",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "total_impression",
        label: "total imp. #",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_impression",
        label: "adx. imp. #",
        group: "b",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_impression_percent",
        label: "adx. imp. %",
        group: "b",
        parsefunc: ({ b_impression, total_impression }) => {
          return total_impression === 0 || b_impression === "-"
            ? 0
            : b_impression / total_impression;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "o_impression",
        label: "adx. imp. #",
        group: "o",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "o_impression_percent",
        label: "adx. imp. %",
        group: "o",
        parsefunc: ({ total_impression, o_impression }) => {
          return total_impression === 0 || o_impression === "-"
            ? 0
            : o_impression / total_impression;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
    ];

    const dateIdx = _.indexOf(columns, "date");
    const idIdx = _.indexOf(columns, "ext_gam_unit_id");
    const groupIdx = _.indexOf(columns, "group_type");
    const impIdx = _.indexOf(columns, "ad_exchange_impression");
    const tabIdx = _.indexOf(columns, "predicted_viewability_bucket");

    const newRecords = [];
    _.forEach(records, (item) => {
      const date = item[dateIdx];
      const id = item[idIdx];
      const group = item[groupIdx];
      const imp = item[impIdx];
      const tab = item[tabIdx];

      let index = _.findIndex(newRecords, (record) => {
        return record[0] === date && record[1] === id && record[2] === tab;
      });

      if (index < 0) {
        newRecords.push([date, id, tab, 0, 0, 0]);
        index = newRecords.length - 1;
      }

      if (group === "b") {
        newRecords[index][3] += imp;
        newRecords[index][5] += imp;
      } else if (group === "o") {
        newRecords[index][4] += imp;
        newRecords[index][5] += imp;
      }
    });

    const result = parseTableData({
      columns: indexColumns,
      arrangeColumns: arrangeColumns,
      records: newRecords,
      mainKey: "ext_gam_unit_id",
      subKey: "date",
      orderKey: "total_impression",
    });

    this.setState({
      ...result,
      columns: arrangeColumns,
      filterGroups: result.groups,
      filterRecords: result.records,
      filterAmount: result.amount,
      tags: [
        {
          value: "predicted_viewability_bucket",
          label: "Predicted Viewability Bucket",
          type: "string",
        },
        ...arrangeColumns.slice(3).map((item) => ({
          value: item.key,
          label: item.label,
          group: item.group,
        })),
      ],
      alias: [
        {
          value:
            "total_impression >= 10000 AND ( o_impression_percent <= 0.88 OR o_impression_percent >= 0.92)",
          label: "Quick Filter",
        },
        {
          func: (inputValue) =>
            `total_impression >= 10000 AND ( o_impression_percent <= ${(
              inputValue - 0.02
            ).toFixed(2)} OR o_impression_percent >= ${(
              inputValue + 0.02
            ).toFixed(2)})`,
          label: "Custom O Impression %",
        },
      ],
    });
  }

  handleSearch(expression) {
    const { records, columns } = this.state;

    const result = filterDataToGroup({
      expression,
      records,
      columns,
      hasSubGroup: true,
    });

    if (result) {
      this.setState({
        ...result,
      });
    }
  }

  render() {
    const { columns, tags, filterAmount, filterGroups, filterRecords, alias } =
      this.state;

    const header = (
      <tr className="bg-gray-100">
        <th className="border px-2 py-1 text-center" colSpan={6}></th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          b
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          o
        </th>
      </tr>
    );

    return (
      <>
        <div className="mb-2">
          <FilterControl
            tags={tags}
            alias={alias}
            handleSearch={this.handleSearch}
          ></FilterControl>
        </div>
        <GroupDataTable
          records={filterRecords}
          groups={filterGroups}
          amount={filterAmount}
          mainKey="ext_gam_unit_id"
          subKey="date"
          columns={columns}
          header={header}
        ></GroupDataTable>
      </>
    );
  }
}

export default PredictedViewabilityView;
